import React, {Component} from 'react'
import PropTypes from 'prop-types'

class SearchByShipmentStatus extends Component {
    _handleChangeShipmentStatus = async e => {
        const {value} = e.target

        await this.props.onChange('shipment_status', value)
        this.props.onSubmit()
    }


    render() {
        const {filter} = this.props
        const {shipment_status} = filter


        return (
            <div className="SearchByLocationType mr-3 mb-2">
                <label htmlFor="" className='mb-0 font-weight-bold'>Shipment status</label>
                <select name="location_type" value={shipment_status} onChange={this._handleChangeShipmentStatus}
                        className="form-control">
                    <option value="all">All</option>
                    <option value="received">Received</option>
                    <option value="pending">Pending</option>
                </select>
            </div>
        )
    }
}

SearchByShipmentStatus.propTypes = {
    filter: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
}

export default SearchByShipmentStatus
